import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sprint from '../../../interfaces/sprint/Sprint';
import Pagination from '../../ui/Pagination/Pagination';
import Table from 'react-bootstrap/Table';
import Badge from 'react-bootstrap/Badge';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort } from '@fortawesome/free-solid-svg-icons';
import SkeletonRow from '../../ui/LoadingSkeleton/SkeletonRow';

interface SprintsPageTableProps {
    sprints: Sprint[];
    isLoading: boolean;
    page: number;
    pageSize: number;
    totalCount: number;
    onPageChange: (page: number) => void;
    setPage: (page: number) => void;
    setPageSize: (size: number) => void;
    handleSort: (columnName: string) => void;
}

const SprintsPageTable: React.FC<SprintsPageTableProps> = ({
    sprints,
    isLoading,
    page,
    pageSize,
    totalCount,
    onPageChange,
    setPage,
    setPageSize,
    handleSort,
}) => {
    const navigate = useNavigate();

    const resetPageSize = (pageNumber: number, newPageSize: number) => {
        setPageSize(newPageSize);
        setPage(pageNumber);
    };

    return (
        <>
            <Table responsive className="common_table">
                <thead>
                    <tr>
                        <th style={{ width: '40%' }}>Name <FontAwesomeIcon className="cursor-pointer" icon={faSort} onClick={() => handleSort("name")} /></th>
                        <th style={{ width: '20%' }}>Start Date <FontAwesomeIcon className="cursor-pointer" icon={faSort} onClick={() => handleSort("startDate")} /></th>
                        <th style={{ width: '20%' }}>End Date <FontAwesomeIcon className="cursor-pointer" icon={faSort} onClick={() => handleSort("endDate")} /></th>
                        <th style={{ width: '20%' }}>Status <FontAwesomeIcon className="cursor-pointer" icon={faSort} onClick={() => handleSort("completed")} /></th>
                    </tr>
                </thead>
                <tbody>
                    {isLoading ? (
                        [...Array(pageSize)].map((_, index) => <SkeletonRow key={index} columns={4} />)
                    ) : sprints.length > 0 ? (
                        sprints.map((sprint) => (
                            <tr key={sprint.id} onClick={() => navigate(`/sprints/${sprint.id}`)} style={{ cursor: 'pointer' }}>
                                <td>{sprint.name}</td>
                                <td>{new Date(sprint.startDate).toLocaleDateString()}</td>
                                <td>{sprint.endDate ? new Date(sprint.endDate).toLocaleDateString() : "--"}</td>
                                <td>
                                    <Badge bg={sprint.completed ? "secondary" : "success"}>
                                        {sprint.completed ? 'Completed' : 'Active'}
                                    </Badge>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan={4} className="text-center">No sprints found.</td>
                        </tr>
                    )}
                </tbody>
            </Table>
            {totalCount > 0 && (
                <Pagination
                    currentPage={page}
                    totalPages={Math.ceil(totalCount / pageSize) || 0}
                    onPageChange={onPageChange}
                    pageSize={pageSize}
                    resetPageSize={resetPageSize}
                />
            )}
        </>
    );
};

export default SprintsPageTable;
